<template>
  <div class="right_nav_box">
    <div class="out_nav_item out_wechat">
      <div class="nav_item wechat" @mouseover="hoverWechat(1)" @mouseout="outWechat(1)">
        <img class="wechat_img" :src="wechatIcon" alt>
        <div class="title">微信</div>
      </div>
      <div class="show_wechat_box">
        <div class="triangle"></div>
        <div class="wecht_box_content">
          <div
            class="wechat_qrcode"
            v-bind:style="{'background-image':'url('+comPath+contactInfo.qrcode+')'}"
          ></div>
          <div class="title_info text_overflow">扫码获取详细产品资料与功能演示</div>
        </div>
      </div>
    </div>
    <div class="out_nav_item out_phone">
      <div class="show_mobile_box">
        <div class="triangle"></div>
        <div class="show_mobile_content">
          <div class="title">
            <div class="title_icon"></div>
            <div class="title_info">立即咨询</div>
          </div>
          <div class="phone_num">{{contactInfo.phone}}</div>
        </div>
      </div>
      <div class="nav_item phone" @mouseover="hoverWechat(2)" @mouseout="outWechat(2)">
        <img class="phone_img" :src="phoneIcon" alt>
        <div class="title">电话</div>
      </div>
    </div>
    <div class="out_nav_item">
      <div class="nav_item kefu" @click="handleJump">
        <img class="kefu_img" src="../assets/images/right_nav_kefu.png" alt>
        <div class="title">在线客服</div>
      </div>
    </div>
    <div class="out_nav_item" @click="toTop()">
      <div class="nav_item toTop">
        <img class="top_img" src="../assets/images/right_nav_to_top.png" alt>
        <div class="title">回到顶部</div>
      </div>
    </div>
  </div>
</template>

<script>
  import wechatImg from "../assets/images/right_nav_wechat.png";
  import wechatActiveImg from "../assets/images/right_nav_wechat_active.png";

  import phoneImg from "../assets/images/right_nav_phone.png";
  import phoneActiveImg from "../assets/images/icon_phone_whiter.png";

  export default {
  data() {
    return {
      wechatIcon: "",
      wechatImg: wechatImg,
      wechatActiveImg: wechatActiveImg,
      phoneIcon: "",
      phoneImg: phoneImg,
      phoneActiveImg: phoneActiveImg,
      contactInfo: {
        email: "",
        logimg: "",
        phone: "",
        qrcode: ""
      },
      scrollHeight:'',
    };
  },
  created() {
    this.getScroll()
  },
  mounted() {
    this.getCcontactInfo();
    this.outWechat(1);
    this.outWechat(2);
  },
  methods: {
    hoverWechat(index) {
      switch (index) {
        case 1:
          this.wechatIcon = this.wechatActiveImg;
          break;
        case 2:
          this.phoneIcon = this.phoneActiveImg;
          break;
      }
    },
    outWechat(index) {
      switch (index) {
        case 1:
          this.wechatIcon = this.wechatImg;
          break;
        case 2:
          this.phoneIcon = this.phoneImg;
          break;
      }
    },
    handleJump() {
      window.open(
        "https://webchat.7moor.com/wapchat.html?accessId=dd038630-752b-11e9-bb51-491463163d37&fromUrl=yuemia.com&urlTitle=official"
      );
    },
    getCcontactInfo() {
      let url = "/api/home/gainglobalstyle";
      this.$http.get(url).then(res => {
        // console.log("底部信息", res);
        if (res.data.ret === 0) {
          this.contactInfo.email = res.data.lister[0].email;
          this.contactInfo.logimg = res.data.lister[0].logimg;
          this.contactInfo.phone = res.data.lister[0].phone;
          this.contactInfo.qrcode = res.data.lister[0].qrcode;
        }
        // console.log(this.contactInfo);
      });
    },
     toTop() {
     // window.scrollTo(0, 0);
      window.eventBus.$emit('toTop',0)
    },
    //获取滚动条滚动的距离
    getScroll() {
      window.eventBus.$on("handleHeight", (val, cHeight, isA) => {
        this.scrollHeight = val;
        // console.log("监听到滚动条的距离")
        // console.log(val)
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../assets/css/baseFontAndColor.styl'
.right_nav_box
  width: 80px
  // height 300px
  box-shadow: 3px 4px 50px rgba(0, 4, 28, 0.09)
  .out_phone:hover .show_mobile_box
    display: block !important
  .out_wechat:hover .nav_item
    background-color: $color-theme-title
  .out_phone:hover .nav_item
    background-color: $color-theme-title
  .out_wechat:hover .title
    color: #fff
    opacity: 1 !important
  .out_phone:hover .title
    color: #fff
    opacity: 1 !important
  .out_nav_item
    width: 80px
    height: 80px
    display: flex
    justify-content: center
    align-items: center
    position: relative
    cursor: pointer
    .nav_item
      width: 74px
      height: 74px
      img
        display: block
        margin: 14px auto 0
      .wechat_img
        width: 36px
        height: 30px
        margin: 14px auto 0
      .phone_img
        width: 24px
        height: 32px
      .kefu_img
        width: 28px
        height: 30px
      .top_img
        width: 28px
        height: 28px
      .title
        font-size: $font-size-12
        color: $font-main-main
        line-height: 18px
        text-align: center
        opacity: 0.3
        margin-top: 5px
    .toTop
      .title
        margin-top: 0
    .wechat:hover + .show_wechat_box
      display: block !important
.show_wechat_box
  width: 160px
  height: 200px
  background: rgba(255, 255, 255, 1)
  border: 1px solid rgba(238, 238, 241, 1)
  border-radius: 6px
  padding: 20px 20px 0
  box-sizing: border-box
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.09)
  opacity: 1
  position: absolute
  right: 100px
  top: -36px
  display: none
  .triangle
    width: 0
    height: 0
    border-left: 20px solid transparent
    border-right: 20px solid #fff
    border-bottom: 20px solid transparent
    transform: rotate(45deg)
    z-index: 9
    position: absolute
    right: -10px
    top: 60px
    box-shadow: 3px 4px 50px rgba(0, 4, 28, 0.09)
  .wecht_box_content
    // padding 20px 20px 0
    .wechat_qrcode
      width: 120px
      height: 120px
      margin-bottom: 6px
      background-size: cover !important
      background-repeat: no-repeat !important
      background-position: center center !important
      // margin 13px auto 0
    .title_info
      text-align: center
      font-size: 13px
      line-height: 18px
      -webkit-line-clamp: 2
.show_mobile_box
  width: 170px
  height: 65px
  position: absolute
  right: 100px
  top: 0px
  display: none
  .triangle
    width: 0
    height: 0
    border-left: 20px solid transparent
    border-right: 20px solid #fff
    border-bottom: 30px solid transparent
    z-index: 9
    position: absolute
    right: 1px
    top: 46%
    transform: translate(0, -50%) rotate(45deg)
  .show_mobile_content
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.09)
    width: 160px
    height: 65px
    padding: 10px 14px 0 14px
    box-sizing: border-box
    background-color: #fff
    border-radius: 10px
    .title
      display: flex
      justify-content: flex-start
      align-items: center
      opacity: 0.6
      .title_icon
        width: 3px
        height: 12px
        background-color: rgba(38, 38, 38, 0.6)
      .title_info
        color: rgba(38, 38, 38, 0.6)
        margin-left: 3px
    .phone_num
      height: 28px
      line-height: 28px
      color: rgba(38, 38, 38, 1)
      font-size: 20px
      margin-left: -2px
</style>



// WEBPACK FOOTER //
// src/components/right_nav.vue